<div id="create-user">
  <div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-primary">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title">
          {{ 'USERS.CREATEUSER.ADD.TITLE' | translate }}</span
        >
        <button
          mat-icon-button
          (click)="matDialogRef.close()"
          aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="user-form">
      <form fxLayout="column" fxFill [formGroup]="addUserForm">
        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label>{{ 'USERS.SINGLE.INFO.AVS' | translate }}</mat-label>
            <input
              matInput
              formControlName="avs"
              required
              placeholder="756.9999.9999.99" />
          </mat-form-field>
        </div>

        <mat-form-field fxFlex appearance="outline">
          <mat-label>
            {{ 'USERS.SINGLE.INFO.FIRSTNAME' | translate }}
          </mat-label>
          <input matInput formControlName="firstName" required />
        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label
              >{{ 'USERS.SINGLE.INFO.LASTNAME' | translate }}
            </mat-label>
            <input matInput formControlName="lastName" required />
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label>{{ 'USERS.SINGLE.INFO.TITLE' | translate }} </mat-label>
            <input matInput formControlName="title" required />
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex appearance="outline">
            <mat-label
              >{{ 'USERS.SINGLE.INFO.DATEOFBIRTH' | translate }}
            </mat-label>
            <input
              matInput
              formControlName="dateOfBirth"
              required
              placeholder="{{
                'USERS.CREATEUSER.ADD.BIRTHDATEPLACEHOLDER' | translate
              }}" />
          </mat-form-field>
        </div>

        <mat-form-field fxFlex="32" appearance="outline">
          <mat-select
            placeholder="{{ 'USERS.SINGLE.INFO.GENDER' | translate }}*"
            formControlName="gender"
            required>
            <mat-option [value]="'M'">
              {{ 'USERS.CREATEUSER.ADD.GENDER-M' | translate }}
            </mat-option>
            <mat-option [value]="'F'">
              {{ 'USERS.CREATEUSER.ADD.GENDER-F' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label> {{ 'USERS.SINGLE.INFO.ADDRESS' | translate }}</mat-label>
          <input matInput formControlName="address" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'USERS.SINGLE.INFO.NPA' | translate }}</mat-label>
          <input matInput formControlName="zip" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'USERS.SINGLE.INFO.LOCALITY' | translate }}</mat-label>
          <input matInput formControlName="locality" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            'USERS.SINGLE.INFO.PREFERREDLANGUAGE' | translate
          }}</mat-label>
          <mat-select formControlName="preferredLanguage">
            @for (lang of preferredLanguage; track lang) {
              <mat-option [value]="lang" required>
                {{ lang.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex="32" appearance="outline">
            <mat-select placeholder="Indicatif" formControlName="defaultDial">
              <mat-option [value]="'+41'"> +41 </mat-option>
              <mat-option [value]="'+33'"> +33 </mat-option>
              <mat-option [value]="'+49'"> +49 </mat-option>
              <mat-option [value]="'+39'"> +39 </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field fxFlex="58" appearance="outline">
            <mat-label>{{ 'USERS.SINGLE.INFO.PHONE' | translate }}</mat-label>
            <input
              matInput
              formControlName="phone"
              [maxLength]="maxlength"
              placeholder="791234567"
              required />
          </mat-form-field>
          <div
            fxFlex="10"
            fxLayoutAlign="center center"
            class="container-form-tooltip">
            <mat-icon
              matTooltip="{{ 'USERS.CREATEUSER.ADD.PHONETOOLTIP' | translate }}"
              class="mat-icon-custom"
              >help</mat-icon
            >
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field fxFlex="90" fxFlex appearance="outline">
            <mat-label>{{ 'USERS.SINGLE.INFO.EMAIL' | translate }}</mat-label>
            <input matInput formControlName="email" required />
          </mat-form-field>
          <div
            fxFlex="10"
            fxLayoutAlign="center center"
            class="container-form-tooltip">
            <mat-icon
              matTooltip="{{ 'USERS.CREATEUSER.ADD.EMAILTOOLTIP' | translate }}"
              class="mat-icon-custom"
              >help</mat-icon
            >
          </div>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>{{
            'USERS.CREATEUSER.ADD.GRPETAB' | translate
          }}</mat-label>
          <mat-select
            fxFill
            formControlName="grpEtablissement"
            [value]="selectedEtablissement"
            (selectionChange)="onChangeEtablissement($event)">
            @for (
              etablissement of currentUser.groupEtablissement;
              track etablissement
            ) {
              <mat-option [value]="etablissement">{{
                etablissement
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (
          !isBusyLoadingRole && availableRoles && availableRoles.length > 0
        ) {
          <mat-form-field appearance="outline">
            <mat-label>{{ 'USERS.SINGLE.INFO.ROLES' | translate }}</mat-label>
            <mat-select fxFill formControlName="roles">
              @for (role of availableRoles; track role) {
                <mat-option [value]="role.name">{{
                  role.displayName
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </form>
    </div>
    @if (isBusy || isBusyLoadingRole) {
      <div
        class="general-container"
        fxLayout="column"
        fxLayoutAlign="center center">
        <div fxFlex="100">
          <mat-progress-spinner
            [color]="spinner.color"
            [mode]="spinner.mode"
            [value]="spinner.value"
            [diameter]="spinner.diameter">
          </mat-progress-spinner>
        </div>
        <br />
        @if (isBusyLoadingRole) {
          <div fxFlex="100">
            {{ 'USERS.CREATEUSER.ROLESLOADING' | translate }}
          </div>
        }
      </div>
    }

    @if (errorGettingRole) {
      <div class="success-container" fxLayout="row" fxFill="100">
        <div class="message-box error user-created">
          {{ 'ERROR.ROLES' | translate }}
        </div>
      </div>
    }

    @if (isErrorUpdate) {
      <div class="general-container" fxLayout="row" fxFill="100">
        <div class="message-box error user-created">
          <app-error-message [error]="error.error" />
        </div>
      </div>
    }

    @if (isUserCreated) {
      <div class="success-container" fxLayout="column" fxFill="100">
        <div class="row">
          <div class="message-box success user-created">
            {{ 'USERS.CREATEUSER.SUCESS' | translate }}
          </div>
        </div>
        <div class="row">
          <button
            mat-raised-button
            matStepperNext
            type="button"
            color="accent"
            class="btn-submit"
            (click)="matDialogRef.close()">
            {{ 'GENERAL.CONFIRMANDLEAVE' | translate }}
          </button>
        </div>
      </div>
    }

    @if (!isUserCreated) {
      <div class="row" class="field-container">
        <div fxFlex="50">
          <button
            mat-raised-button
            type="button"
            color="accent"
            (click)="CreateUser()"
            [disabled]="addUserForm.invalid || isBusy">
            {{ 'GENERAL.SAVE' | translate }}
          </button>
        </div>
        <div fxFlex="50" fxLayoutAlign="end">
          <button
            mat-raised-button
            matStepperNext
            type="button"
            color="warn"
            (click)="matDialogRef.close()">
            {{ 'GENERAL.CANCEL' | translate }}
          </button>
        </div>
      </div>
    }
  </div>
</div>
